<template>
  <div
    class="modal theme-modal fade show"
    style="display: block; padding-right: 15px;"
    aria-modal="true"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="border modal-content">
        <div class="top-0 z-1 position-absolute me-3 mt-3 end-0">
          <button
            class="d-flex flex-center transition-base btn-close btn btn-sm btn-circle"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="handleClose"
          />
        </div>

        <div class="bg-body-tertiary py-3 ps-4 pe-6 rounded-top-3">
          <h4
            id="staticBackdropLabel"
            class="mb-1"
          >
            디바이스 등록/수정
          </h4>
          <p
            v-if="isEditMode"
            class="mb-0 fs-11"
          >
            디바이스 이름 : <a
              class="link-600 fw-semi-bold"
              href="#!"
            >{{ formatDevice.devicename }}</a>
          </p>
        </div>

        <div class="px-card pt-1 pb-card modal-body fs--1">
          <div class="mt-3 media">
            <div class="media-body">
              <div class="text-800 fs--1">
                <div class="d-flex align-items-center modal_div">
                  <h6 class="me-2 mb-0 device-title">
                    디바이스 종류
                  </h6>
                  <select
                    v-model="formatDevice.dcode"
                    class="me-2 form-select-sm select-month form-select"
                    style="width:100%; display:inline;"
                  >
                    <option
                      v-for="dcode in dcodeList"
                      :key="dcode.dcode"
                      :value="dcode.dcode"
                    >
                      {{ dcode.dcodename }}
                    </option>
                  </select>
                </div>
                <div class="d-flex align-items-center modal_div">
                  <h6 class="me-2 mb-0 device-title">
                    디바이스 아이디
                  </h6>
                  <input
                    id="input-setinterval"
                    v-model="formatDevice.deviceid"
                    class="form-control"
                    type="text"
                    placeholder=""
                    style="width:100%"
                    :disabled="isEditMode"
                  >
                </div>

                <div class="d-flex align-items-center modal_div">
                  <h6 class="me-2 mb-0 device-title">
                    디바이스 이름
                  </h6>
                  <input
                    id="input-setinterval"
                    v-model="formatDevice.devicename"
                    class="form-control"
                    type="text"
                    placeholder=""
                    style="width:100%"
                  >
                </div>

                <div class="d-flex align-items-center modal_div">
                  <h6 class="me-2 mb-0 device-title">
                    센서 설정
                  </h6>
                  <a
                    class="me-2 btn btn-falcon-default btn-sm"
                    @click="sensorAdd"
                  >
                    <span
                      class="fs--2"
                      data-fa-i2svg=""
                    />추가
                  </a>
                  <a
                    class="me-2 btn btn-falcon-default btn-sm"
                    @click="sensorUpdate"
                  >
                    <span
                      class="fs--2"
                      data-fa-i2svg=""
                    />수정
                  </a>
                  <a
                    class="btn btn-falcon-default btn-sm"
                    @click="sensorDelete"
                  >
                    <span
                      class="fs--2"
                      data-fa-i2svg=""
                    />삭제
                  </a>
                </div>

                <div class="d-flex align-items-center modal_div">
                  <h6 class="me-2 mb-0 device-title">
                    센서 리스트
                  </h6>    
                </div>
                <CommGrid
                  ref="sensorGridRef"
                  :rows="svList"
                  :columns="columnDefs"
                  :is-check-box="true"
                  :set-grid-height="300"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <a
            class="btn btn-falcon-default btn-sm"
            @click="handleSave"
          >
            <span
              class="mr-2 fs--2"
              data-fa-i2svg=""
            />저장
          </a>
          <a
            class="btn btn-falcon-default btn-sm"
            @click="handleClose"
          >
            <span
              class="mr-2 fs--2"
              data-fa-i2svg=""
            />취소
          </a>
        </div>
      </div>
    </div>
  </div>

  <SensorManagerModal
    v-if="SensorManagerShowModal"
    v-model:setsensor="setsensor"
    @sensor-close="SensorManagerShowModal = false"
    @sensor-save="sensorModalSave"
  />  

  <SensorListModal
    v-if="SensorListShowModal"
    :setdevice="formatDevice"
    @sensor-list-close="SensorListShowModal = false" 
    @sensor-list-add="onSenserListAddOk"
  />  

  <AlertModal ref="alertModalRef" />
</template>

<script setup lang="ts">

import type { Client, ColumnDefinition, Device, DeviceCode, Sensor, SensorManager} from '@/types/commontypes'
import { onMounted, ref, computed, watch} from 'vue';
import AlertModal from "@/components/AlertModal.vue";
import CommGrid from '../components/CommGrid.vue'
import SensorManagerModal from '../components/SensorManagerModal.vue'
import SensorListModal from '../components/SensorListModal.vue'

const emit = defineEmits(['DeviceClose', 'DeviceSave'])

const props = defineProps<{
    selectclient: Client;
    setdevice: Device | null;
    isEditMode: boolean;
}>();

const defaultDevice: Device = {
        dcode: '',
        deviceid: '',
        clientcode: '',
        devicename: '',
        svlist: '[]',
        regdt: '',
        config: '',
        alertconfig: '',
        configdt: '',
        configuse: 0,
        df1_status: 0, df2_status: 0, df3_status: 0, df4_status: 0, df5_status: 0,
        df6_status: 0, df7_status: 0, df8_status: 0, df9_status: 0, df10_status: 0,
        df11_status: 0, df12_status: 0, df13_status: 0, df14_status: 0, df15_status: 0,
        df16_status: 0, df17_status: 0, df18_status: 0, df19_status: 0, df20_status: 0,
        df21_status: 0, df22_status: 0, df23_status: 0, df24_status: 0, df25_status: 0,
        df26_status: 0, df27_status: 0, df28_status: 0, df29_status: 0, df30_status: 0
    }

const alertModalRef = ref();

const formatDevice = ref<Device>({...defaultDevice});
const dcodeList = ref<DeviceCode[]>([])
const selectDCode = ref<string|null>(null)
const setsensor = ref<Sensor>({} as Sensor)

// sensor list grid 관련
const svList = ref<SensorManager[]>([]);
const columnDefs = ref<ColumnDefinition[]>([]);

const SensorManagerShowModal = ref(false)
const sensorGridRef = ref();
const checkedSensorRows = ref<SensorManager[]>([]);

// sensor list 추가 팝업
const SensorListShowModal = ref(false)

onMounted(async () =>{
  initDevice();
  setSVList();
});

const initDevice = () => {
    loadDCode();

    if(props.isEditMode && props.setdevice) {
        selectDCode.value = props.setdevice.dcode;
    }
}

watch(() => props.setdevice, 
    (newval) => {
        if(newval)
            formatDevice.value = {...newval}
        else
            formatDevice.value = {...defaultDevice}    
    },
    { immediate: true, deep: true }
)

const isEditMode = computed((): boolean => {
    return !!props.isEditMode;
})

function setSVList() {
    const columnList: ColumnDefinition[] = [
        { field: 'uid', label: 'uid'},
        { field: 'sindex', label: 'ID'},
        { field: 'sname', label: '센서명'},
        { field: 'protocol', label: 'protocol'},
        { field: 'unit', label: '단위'},
        { field: 'dpoint', label: '소수점'}
    ]

    columnDefs.value = [...columnList];

    const svlist = JSON.parse(formatDevice.value.svlist);
    svlist.map((sitem: SensorManager, index: number) => {
        sitem.uid = index
    })
    
    svList.value = svlist;
}

function loadDCode() {
    const data = JSON.stringify({ 'operator': "getdcodelist"});
	
	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', () => {
        const result = xhr.responseText;
        const retJSON = JSON.parse(result);
        for(var i in retJSON) {
            dcodeList.value.push(retJSON[i]);
        }
    });
}

/**
 * 센서 추가 버튼 처리
 */
function sensorAdd() {
    SensorListShowModal.value = true;
}

/**
 * 센서 정보 수정 버튼 처리
 */
function sensorUpdate() {
    checkedSensorRows.value = sensorGridRef.value.selectedRows;
    if(!checkedSensorRows.value || checkedSensorRows.value.length <= 0) {
        alertModalRef.value.showAlertModal("경고", "수정할 센서를 선택하세요.");
        return;
    }

    if(checkedSensorRows.value.length > 1) {
        alertModalRef.value.showAlertModal("경고", "1개의 센서만 선택해 주세요.");
        return;
    }

    // Sensor update modal 에 전달하는 sensor 정보
    setsensor.value = checkedSensorRows.value[0];
    // Sensor update modal 띠우기
    SensorManagerShowModal.value = true;
}

/**
 * 센서리스트 삭제 버튼 처리
 */
function sensorDelete() {
    checkedSensorRows.value = sensorGridRef.value.selectedRows;
    if(!checkedSensorRows.value || checkedSensorRows.value.length <= 0) {
        alertModalRef.value.showAlertModal("경고", "삭제할 센서를 선택하세요.");
        return;
    }

    const selids = checkedSensorRows.value.map(citem => citem.uid);
    svList.value = svList.value.filter((sitem) => !selids.includes(sitem.uid));

    formatDevice.value.svlist = JSON.stringify(svList.value)
}

/**
 * 센서 속성 설정 모달에서 저장 처리에 대한 부모에서의 처리
 */
function sensorModalSave() {
    const idx = svList.value.findIndex(s => s.protocol === setsensor.value.protocol);
    if (idx !== -1) {
        svList.value[idx] = { ...setsensor.value };
    }

    // formatDevice.value.svlist도 문자열로 다시 반영
    formatDevice.value.svlist = JSON.stringify(svList.value);

    SensorManagerShowModal.value = false
}

const handleClose = () => {
    emit('DeviceClose')
}

/**
 * 디바이스 등록/수정 저장 버튼 처리
 */
const handleSave = () => {
    if(!formatDevice.value.deviceid) {
        alertModalRef.value.showAlertModal("경고", "디바이스 아이디를 입력해 주세요.");
        return;
    }

    if(!formatDevice.value.devicename) {
        alertModalRef.value.showAlertModal("경고", "디바이스 이름을 입력해 주세요.");
        return;
    }
    
    if(formatDevice.value.svlist.length <= 0 ) {
        alertModalRef.value.showAlertModal("경고", "센서를 설정해 주세요.");
        return;
    }

    const snameMap: Record<string, boolean> = {};
    let bcheck = "";
    const svlist = JSON.parse(formatDevice.value.svlist);

    for (const item of svlist as Sensor[] ) {
        if (snameMap[item.protocol]) {
            bcheck = item.protocol;
            break;
        }
        snameMap[item.protocol] = true;
    }
    if(bcheck != "") {
        alertModalRef.value.showAlertModal("경고", `${bcheck} protocol 이 중복되게 설정되었습니다.`);
        return;
    }

    let data;
    if(isEditMode.value === false) {
        // 등록모드
        data = { 'operator': "addDeviceEx", 
                "dcode":formatDevice.value.dcode, 
                'deviceid' : props.selectclient.clientcode + formatDevice.value.deviceid, 
                'devicename' : formatDevice.value.devicename, 
                "clientcode": props.selectclient.clientcode, 
                'svobjlist' : svlist};
    } else {
        // 수정모드
        data = { 'operator': "updateDeviceEx", 
                "dcode":formatDevice.value.dcode, 
                'deviceid' : formatDevice.value.deviceid, 
                'devicename' : formatDevice.value.devicename, 
                "clientcode": props.selectclient.clientcode, 
                'svobjlist' : svlist};
    }

    const data2 = JSON.stringify(data)
    var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data2);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', () => {
        const result = xhr.responseText;
        const retJSON = JSON.parse(result);
        if(retJSON.err == 0) {
            //console.log("success!");
            //$('#deviceModal').modal("hide");
            // 데이타를 다시 불러옴
            //LoadDeviceList(getclientcode2);
            emit('DeviceSave');
        } else {
            console.log("failed! ", retJSON.err);
            alertModalRef.value.showAlertModal("경고", `디바이스 등록/수정이 실패 했습니다. ${retJSON.err}`);

            //if(g_mode == 0)
            //    alert($.t('deviceman.alert.deviceregfailed') + result.err);
            //else
            //    alert($.t('deviceman.alert.deviceupdatefailed') + result.err);
        }
    });
}

/**
 * 센서추가 팝업에서 확인버튼 처리에 대한 처리
 */
function onSenserListAddOk() {
    SensorListShowModal.value = false
    setSVList();
}

</script>

<style lang="">
    
</style>